module.exports = __webpack_public_path__ + "img/filter-type-back.f3b7b89c.svg";